import { render, staticRenderFns } from "./EquipmentItemFilesTable.vue?vue&type=template&id=3b66d5fe"
import script from "./EquipmentItemFilesTable.vue?vue&type=script&lang=js"
export * from "./EquipmentItemFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports